import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { Subscription, timer } from 'rxjs';

import { IToaster, SdListComponent, SdToasterComponent } from '@seb/web-design-system/core';
import { ToasterService } from '../../../../services';

export interface DataToaster {
  id: number;
  toaster: IToaster;
}

const TOASTER_DISPLAY_PERIOD = 4000;

@Component({
  selector: 'wc-toaster',
  templateUrl: './toaster.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdListComponent,
    SdToasterComponent
  ]
})
export class ToasterComponent implements OnInit, OnDestroy {
  dataToasterList = signal<DataToaster[]>([]);
  toasterService = inject(ToasterService);
  subscriptions = new Subscription();
  nextId = 0;

  ngOnInit(): void {
    this.subscriptions.add(
      this.toasterService.toasterSubject$.subscribe((toaster) => {
        this.addToaster(toaster);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private addToaster(toaster: IToaster): void {
    if (toaster.title === 'account.expiration') {
      const sameFound = this.dataToasterList().find((t) => t.toaster.title === toaster.title);
      if (sameFound) {
        return;
      }
    }

    const dataToaster: DataToaster = {
      id: this.nextId++,
      toaster
    };

    this.subscriptions.add(
      timer(TOASTER_DISPLAY_PERIOD).subscribe(() => {
        this.dataToasterList.update((list) => list.filter((t) => t.id !== dataToaster.id));
      })
    );

    this.dataToasterList.update((list) => [dataToaster, ...list]);
  }
}
